// Re-export all actions and selectors from the reducers
export * from './ownersReducer'
export * from './ticketReducer'
export * from './checkedInReducer'
export * from './uiReducer'

// Combined reset action
import { resetTicket } from './ticketReducer'
import {
  resetOwnersList,
  updateQuery as updateOwnersQuery,
  forceSearch as forceOwnersSearch,
} from './ownersReducer'
import { updateQueryForTicket, forceSearchTicket } from './ticketReducer'
import { resetUI } from './uiReducer'

// Keep the original scanner behavior by updating owners and ticket lookup together.
export const updateQuery = (query) => (dispatch) => {
  dispatch(updateOwnersQuery(query))
  dispatch(updateQueryForTicket(query))
}

export const forceSearch = (query) => (dispatch) => {
  dispatch(forceOwnersSearch(query))
  dispatch(forceSearchTicket(query))
}

export const resetAll = () => (dispatch) => {
  dispatch(resetTicket())
  dispatch(resetOwnersList())
  dispatch(resetUI())
}
